import { IBmtBillingState } from './state';

export const getEbillRequest = (state: { billingState: IBmtBillingState }): any => state.billingState.ebillRequest;

export const getEbillError = (state: { billingState: IBmtBillingState }): any => state.billingState.ebillError;

export const isFetching = (state: { billingState: IBmtBillingState }): any => state.billingState.isFetching;

export const getAchError = (state: { billingState: IBmtBillingState }): any => state.billingState.achPaymentError;